import { render } from "./MeetingCharacteristics.vue?vue&type=template&id=6e55deb2"
import script from "./MeetingCharacteristics.vue?vue&type=script&lang=js"
export * from "./MeetingCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script